// i18n area 'networks' — locale et-EE (task #171, onda 3): tradotto DALL'ITALIANO,
// che è la lingua SORGENTE (regola ratificata 2026-08-03); gli anglicismi del
// sorgente si TRASLANO, non si traducono. Sidecar anti-stantie: ../meta/networks.et-EE.meta.json.
import type { enUS } from './networks'

export const etEE: typeof enUS = {
  networks: {
    common: {
      name: 'Nimi',
      scope: 'Scope',
      operState: 'Olek',
      actions: 'Toimingud',
      create: 'Loo',
      close: 'Sulge',
      cancel: 'Loobu',
      delete: 'Kustuta',
      edit: 'Muuda',
      save: 'Salvesta',
      editError: 'Muutmine ebaõnnestus',
      search: 'Otsi nime järgi',
      empty: 'Siin pole veel midagi',
      saveError: 'Salvestamine ebaõnnestus',
      loadError: 'Laadimine ebaõnnestus — kas TVirti backend on kättesaadav?',
      createError: 'Loomine ebaõnnestus',
      deleteError: 'Kustutamine ebaõnnestus',
      deleteConfirmTitle: 'Kas kustutada {name}?',
      deleteConfirmBody: 'Toiming pole tagasipööratav.',
      nameHint: 'Väiketähed, numbrid ja sidekriipsud (DNS-1123)',
      up: 'Aktiivne',
      down: 'Pole aktiivne',
      unknown: 'Teadmata',
      usedByVMs: 'VM-id',
      emptyTable: 'Ühtegi kirjet pole — lisa üks nupuga +'
    },
    dialogTabs: {
      general: 'Üldine',
      base: 'Põhimääratlus',
      advanced: 'Täpsem konfiguratsioon',
      reserved: 'TVirtile reserveeritud vahemikud',
      position: 'Asukoht',
      network: 'Võrgu konfiguratsioon',
      hosts: 'Osalevad sõlmed'
    },
    reservedRanges: {
      note: 'Need on TVirtile reserveeritud IP-vahemikud, mida ta saab kasutada, et anda VM-idele, konteineritele jms automaatselt aadress. MÄRKUS: nendesse vahemikesse jäävaid IP-aadresse ei tohi väljaspool TVirti kasutada ükski väline teenus ega seade.',
      from: 'Alates',
      to: 'Kuni'
    },
    overlay: {
      title: 'Overlay-võrgud',
      createTitle: 'Loo overlay-võrk',
      editTitle: 'Muuda overlay-võrku',
      vni: 'VNI',
      vniHint: 'VXLAN Network Identifier — tühjaks jättes määratakse automaatselt',
      subnet: 'Alamvõrk',
      subnetHint: 'Overlay CIDR — IPAM tuletab sellest automaatselt registrikirje',
      mtu: 'MTU',
      weight: 'Kaal',
      ceilMbps: 'Ülempiir (Mbps)',
      fairnessHint: 'Kaal loeb ainult konkurentsi korral: vabal lingil võib iga võrk kasutada kogu ribalaiust. Ülempiir kehtib aga alati.',
      contention: 'Konkurents',
      contentionTip: 'Vähemalt üks sõlm näeb selle võrgu klassil pakettide kadu või overlimit-e KOOS järjekorraga: uplingi ribalaius on jagatud surve all ja kaalud mõjuvad. Kui palju ja mis ajast — sõlme net.shaping.* seeriates.',
      firewallPolicy: 'Firewalli poliitika',
      hosts: 'Hostid',
      hostsTitle: 'Osalevad sõlmed',
      hostsHint: 'Iga sõlm deklareerib oma underlay-endpointi — valik sõlme PÄRIS aadressidest, mis loetakse tema võrgukonfiguratsioonist; valikuline overlay-aadress peab jääma alamvõrku. Osalemine ongi paigutuse piirang.',
      hostNode: 'Sõlm',
      hostUnderlay: 'Underlay-IP',
      hostUnderlayPickNode: 'Vali kõigepealt sõlm',
      hostAddress: 'Aadress overlay-võrgus (valikuline)',
      hostAddressOutside: 'Väljaspool overlay alamvõrku ({cidr})',
      addHost: 'Lisa sõlm',

      // Voor #156 (dialoogi standard): üksikasjade dialoogi vaadeldud read.
      observedAt: 'Vaadeldud',
      attachedNics: 'Ühendatud NIC-id'
    },
    services: {
      title: 'Võrguteenused',
      createTitle: 'Loo võrguteenus',
      editTitle: 'Muuda võrguteenust',
      kind: 'Tüüp',
      kindCategory: 'Teenused',
      selectKindHint: 'Vali teenuse tüüp — selle all töötav deemon on teostusdetail, mille TVirt sinu eest ära korraldab.',
      kindLabel: {
        dhcp: 'DHCP-server',
        ntp: 'NTP-server',
        vpn: 'VPN-server',
        dns: 'DNS-server',
        gateway: 'Gateway',
        'lb-rp': 'Koormusjaotur ja reverse proxy',
        floatip: 'Ujuv IP'
      },
      kindDesc: {
        dhcp: "Määrab aadressid teenindatavates alamvõrkudes — kogumid tuletatakse võrgu alamvõrgust, gateway'st ja TVirtile reserveeritud vahemikest.",
        dns: 'Autoriteetne DNS deklareeritud tsoonides — kirjed tuletatakse IPAM-ist, lisaks sinu käsitsi lisatud kirjed.',
        gateway: 'Sõlm on võrgu gateway — NAT (DNAT, 1:1, SNAT/masquerade) ning staatiline marsruutimine ühendatud võrkude vahel, juba oma ehituselt isetervenev.',
        'lb-rp': 'Koormusjaotur / pöördproksi teie teenuste ees — L4 või L7 kuulajad liikmete kogumite või Podi valmis eksemplaride kohal, ümber seadistatud lennult.',
        ntp: 'Võrkude ajateenus — väliste upstream-serverite relee või teenindava sõlme kell, mis serveeritakse klientidele.',
        vpn: 'VPN-kontsentraator sõlmes — WireGuard või OpenVPN, valik on sinu: kaugjuurdepääs rändavatele klientidele või site-to-site tunnel kahe võrgu vahel.',
        floatip: 'Üks aadress, mis asub korraga ainult ühel tervel App-eksemplaril või Podil ja liigub selle kukkumisel järgmisele tervele sihtmärgile — failover ilma deemoniteta; koormusjaotus jääb koormusjaoturile.'
      },

      // Round Pod nativi P4: l'IP flottante (4b) e il backend Pod dell'lb-rp (4a).
      floatip: {
        hint: 'Ujuv IP elab valitud võrgus LISAaadressina hoidja-eksemplari enda nimeruumis: ei porte, ei koormusjaotust, ei NAT-i — kliendi IP jääb tõeliseks.',
        address: 'Ujuv IP',
        targets: 'Sihtmärgid',
        targetsHint: 'EELISTUSE järjekorras: esimene terve sihtmärk hoiab aadressi. Pod tähendab kõiki tema eksemplare, replika kaupa; igal sihtmärgil on oma tervisekriteerium. Iga sihtmärk peab olema ühendatud samasse võrku.',
        targetKind: 'Sihtmärk',
        targetApp: 'App-eksemplar',
        targetPod: 'Pod (kõik eksemplarid)',
        targetRef: 'Milline',
        health: 'Tervis',
        healthRunning: 'Töötab (iga konteiner valmis)',
        healthTcp: 'TCP-ühendus',
        healthHttp: 'HTTP GET',
        healthPing: 'Ping',
        port: 'Port',
        path: 'Tee',
        addTarget: 'Lisa sihtmärk',
        moveUp: 'Liiguta üles',
        moveDown: 'Liiguta alla',
        preempt: 'Preempt',
        preemptHint: 'Väljas (vaikimisi): terve hoidja jätab aadressi endale isegi kui kõrgem sihtmärk naaseb — ei mingit võbelemist. Sees: esimene terve sihtmärk hoiab seda alati.',
        holder: 'Hoidja',
        noHolder: 'tervet sihtmärki pole',
        since: 'alates',
        verdicts: 'Vaadeldud sihtmärgid',
        healthy: 'terve',
        unhealthy: 'ebaterve',
        noVerdict: 'Veel otsustamata — autoriteedisõlm kirjutab esimese otsuse oma järgmisel käigul.',
        vipChip: 'VIP {address}',
        vipChipTooltip: 'See eksemplar hoiab teenuse {service} ujuvat IP-d {address}'
      },
      poolSource: 'Lõpp-punktid',
      poolSourceMembers: 'Staatilised liikmed',
      poolSourcePod: 'Podi valmis eksemplarid',
      poolBackendPod: 'Pod',
      poolBackendPort: 'Port',
      poolBackendHint: 'Lõpp-punktid järgivad Podi: eksemplar liitub, kui see töötab iga konteineriga valmis, ja lahkub kohe, kui seda vähendatakse või see sureb. Aktiivne kontroll on vaikimisi sees.',
      poolBackendCount: 'Podi {pod} valmis eksemplarid pordil {port}',
      node: 'Sõlm',
      enabled: 'Lubatud',
      parked: 'Pargitud',
      subnets: 'Alamvõrgud',
      subnetsHint: "Selle instantsi teenindatavad IPAM-i alamvõrgud — kogumid tuletatakse CIDR-ist, gateway'st ja TVirtile reserveeritud vahemikest",
      noSubnets: 'IPAM-i alamvõrke pole — deklareeri kõigepealt loogiline fabric-võrk (või overlay-alamvõrk): IPAM tuletab need nendest',
      iface: 'Kuulamisliides',
      ifaceHint: 'Hosti liides, millel teenus oma sokli avab (nt sild) — kohustuslik: võrguteenus on iseseisev, "kõik liidesed" enam ei eksisteeri',
      dns: 'DNS-server',
      domain: 'Domeen',
      detail: 'Teenindab',
      subnetCount: '{n} alamvõrku',
      zones: 'Tsoonid',
      zonesHint: 'Ainult autoriteetne — deemon ei tee kunagi rekursiooni. A-kirjed tuletatakse viidatud IPAM-i alamvõrkudes olevate sõlmede deklareeritud aadressidest; reverse-lüliti teenindab ka vastavaid in-addr.arpa tsoone (PTR). Üht tsooni teenindab kogu pargis kõige rohkem üks DNS-instants. Valikuline nameserver on FQDN, mis kirjutatakse NS- ja SOA-kirjetesse vaikeväärtuse ns.<tsoon> asemel; kui see jääb tsooni sisse, tuletatakse tema A-kirje ikkagi teenindavast sõlmest.',
      zoneName: 'Tsooni nimi',
      zoneNs: 'Nameserver (NS)',
      zoneSubnets: 'IPAM-i alamvõrgud',
      zoneReverse: 'Reverse (PTR)',
      zoneRecords: 'Käsitsi kirjed',
      zoneRecordsHint: 'Üks rea kohta: nimi TÜÜP väärtus — tüübid A, CNAME, MX, TXT. Nimekonflikti korral võidab käsitsi kirje tuletatu üle.',
      addZone: 'Lisa tsoon',

      // lb-rp (kolmanda laine vundament): listenerid inline-kogumite peal —
      // ilma eraldi engine'ita, ümber konfigureeritav lennult.
      lbListeningHint: 'Instants deklareerib ÜHE kuulamisvõrgu ja ÜHE aadressi — iga listener seob selle oma pordil; teine aadress on teine teenus.',
      listeners: 'Listenerid',
      listenersHint: 'Iga listener seob instantsi aadressi oma pordil režiimis L4 (TCP passthrough — baite ei avata kunagi) või L7 (HTTP) ja edastab ühte allolevatest poolidest. Aadressi/pordi paari teenindab kuni üks instants noodi kohta. Muudatused rakenduvad lennult — ilma taaskäivituseta, ühendusi kaotamata.',
      listenerName: 'Nimi',
      listenerMode: 'Režiim',
      modeL7: 'L7 — HTTP reverse proxy',
      modeL4: 'L4 — TCP passthrough',
      listenerPort: 'Port',
      listenerPool: 'Kogum',
      addListener: 'Lisa listener',
      pools: 'Kogumid',
      poolsHint: 'Backendid, kuhu liiklus maandub: staatilised liikmed, mida tasakaalustatakse round-robini või vähima koormuse järgi, koos valikulise aktiivse health checkiga, mis võtab haiged liikmed rotatsioonist välja.',
      poolName: 'Nimi',
      poolAlgorithm: 'Algoritm',
      algoRoundRobin: 'Round robin',
      algoLeastRequest: 'Vähim koormatud',
      poolCheck: 'Health check',
      checkNone: 'Puudub',
      checkTcp: 'TCP-ühendus',
      checkHttp: 'HTTP',
      poolCheckPath: 'Sondi teekond',
      poolInterval: 'Intervall (s)',
      poolMembers: 'Liikmed',
      poolMembersHint: 'Üks rea kohta: aadress:port, valikuliselt järgneb kaal (1-128) — nt 10.0.0.21:8080 2',
      addPool: 'Lisa kogum',
      memberCount: '{n} liiget',

      // ntp (ntp voor — ratifitseeritud 2026-08-03, perekonna viimane kind):
      // režiim inimkeeles, upstreami loend ainult seal, kus see midagi
      // tähendab, võrguühendus taaskasutab gateway silte.
      listen: {
        assignment: 'Määramine',
        assignmentStatic: 'Staatiline aadress',
        assignmentAuto: 'Automaatne (TVirti reserveeritud vahemikud)',
        autoHint: 'TVirt võtab aadressi loogilise võrgu reserveeritud vahemikest ja hoiab seda sticky\'na — mitte kunagi uuesti võetud muutmisel või failoveril.',
        title: 'Listenerid',
        hint: 'Võrguteenus on iseseisev: iga listener deklareerib oma võrgu (overlay, fabricu loogiline võrk või toores liides) ja aadressi selle alamvõrgus — üks listener aadressi kohta, metamärki enam ei ole. DNS ja NTP võivad kuulata mitmel võrgul ja nende võrkude mitmel aadressil.',
        address: 'Kuulamisaadress',
        add: 'Lisa listener'
      },
      ntp: {
        mode: 'Sünkroonimisrežiim',
        modeRelay: 'Väliste serverite relee',
        modeNodeClock: 'Sõlme kell',
        modeHint: 'Relee serveerib aega, mis on võetud deklareeritud upstream-serveritest; sõlme kell serveerib teenindava sõlme aega — mida klaster hoiab niikuinii sünkroonis',
        servers: 'Upstream-serverid',
        serversHint: 'Komadega eraldatud — hostinimi või IP-aadress; teenus võtab aja siit ja serveerib selle võrku',
        port: 'Kuulamisport',
        listening: 'Kuulab aadressil'
      },

      vpn: {
        engine: 'Mootor',
        engineHint: 'Valiku teed sina ja pärast see enam ei muutu: WireGuard on moodne, kiire ja kernelis; OpenVPN on ühilduvuse veteran (TCP, vaenulikud võrgud)',
        engineLocked: 'Mootor on muutumatu — teine mootor tähendab uut teenust, võtmed ja sertifikaadid ei ole ülekantavad',
        mode: 'Režiim',
        modeRemote: 'Kaugjuurdepääs',
        modeSite: 'Site-to-site',
        modeHint: 'Kaugjuurdepääs annab rändavatele klientidele aadressi tunnelis; site-to-site ühendab kaks võrku',
        port: 'Kuulamisport',
        protocol: 'Transport',
        protocolWireguardHint: 'WireGuard räägib ainult UDP-d',
        tunnelSubnet: 'Tunneli alamvõrk',
        tunnelSubnetHint: 'Võrk, kus kliendid elavad — kantud IPAM-i registrisse, sünnib ja sureb koos selle teenusega',
        dnsServers: 'Klientidele lükatavad DNS-serverid',
        routes: 'Klientidele lükatavad marsruudid',
        routesHint: 'Komadega eraldatud võrgud, mis on tunneli kaudu kättesaadavad; tunneli alamvõrk on alati kaasas',
        peers: 'Peerid',
        peersHint: 'Jäta avalik võti tühjaks ja TVirt genereerib võtmepaari — seejärel annab selle koos profiiliga üle. Kleebi võti sisse ja peer jääb omaenda võtme juurde.',
        clients: 'Kliendid',
        clientsHint: 'Iga klient saab sertifikaadi, mille väljastab selle teenuse CA. Kliendi eemaldamine TÜHISTAB tema sertifikaadi: CRL genereeritakse kohe uuesti.',
        peerName: 'Nimi',
        publicKey: 'Avalik võti',
        publicKeyMinted: 'Selle genereerib TVirt',
        peerAddress: 'Aadress tunnelis',
        peerAddressHint: 'Tühi = määratakse automaatselt',
        allowedIps: 'Kaugalamvõrgud',
        allowedIpsHint: 'Komadega eraldatud, marsruuditakse läbi selle peeri',
        endpoint: 'Endpoint',
        presharedKey: 'Eeljagatud võti',
        keepalive: 'Keepalive (s)',
        addPeer: 'Lisa peer',
        addClient: 'Lisa klient',
        auth: 'Autentimine',
        authTls: 'Sertifikaadid (TLS)',
        remote: 'Kaugendpoint',
        remoteHint: 'kaugotsa host:port — tühi tähendab, et see pool jääb ootama',
        peerRoutes: 'Kaugalamvõrgud',
        serverPublicKey: 'Selle serveri avalik võti',
        ca: 'Sertifitseerimiskeskus',
        listening: 'Kuulab aadressil',
        tunnel: 'Tunnel',
        peerCount: '{n} peeri',
        download: 'Laadi profiil alla',
        downloadError: 'Profiili eksportimine ebaõnnestus',
        lastHandshake: 'Viimane handshake',
        never: 'mitte kunagi',
        traffic: '↓ {rx} · ↑ {tx}',
        connected: 'Ühendatud',
        idle: 'Jõude'
      },

      // Gateway (kolmas laine — sündis nat'ina, ratifitseeritud 2026-08-01/02;
      // ümber nimetatud ja laiendatud 2026-08-03): kolm NAT-reeglite perekonda
      // pluss staatilised marsruudid kuulataval võrgul. Toetatud on iga
      // ratifitseeritud vorm.
      gateway: {
        attach: 'Kuulatava võrgu tüüp',
        attachOverlay: 'Overlay-võrk',
        attachNetwork: 'Loogiline fabric-võrk',
        attachInterface: 'Toorliides',
        overlay: 'Overlay-võrk',
        network: 'Loogiline võrk',
        interface: 'Liidese nimi',
        interfaceHint: 'Hosti liides, mida TVirt ei halda — aadress võetakse tõe pähe',
        address: 'Kuulamisaadress (gateway)',
        addressHint: 'Gateway aadress, millele kliendid osutavad — kuulatava võrgu alamvõrgu sees',
        dnatTitle: 'DNAT-reeglid',
        dnatHint: 'Sihtkoha NAT: sobivusse jääv liiklus suunatakse ümber uuele aadressile (ja valikuliselt uuele pordile). Iga loendis olev protokoll — pordid seal, kuhu protokoll need viib.',
        snatTitle: 'SNAT-reeglid',
        snatHint: 'Lähte-NAT: sobivusse jääv liiklus väljub ümberkirjutatud lähtega — selgesõnaline uus aadress (ja valikuliselt uus port) või masquerade väljumisaadressil, kui väli jäetakse tühjaks.',
        oneToOneTitle: '1:1 NAT-i reeglid',
        oneToOneHint: 'Iga välisele aadressile saabuv pakett vastendub sisemisele ja sisemine host väljub välisena — kõik protokollid, mõlemad suunad.',
        external: 'Väline aadress',
        internal: 'Sisemine aadress',
        addOneToOne: 'Lisa 1:1 reegel',
        family: 'Perekond',
        protocol: 'Protokoll',
        source: 'Lähe (aadress/alamvõrk)',
        destination: 'Sihtkoht (aadress/alamvõrk)',
        invert: 'NOT',
        srcPorts: 'Lähtepordid',
        dstPorts: 'Sihtpordid',
        dstPortsHint: 'Port või vahemik (80, 8000-8099)',
        toAddress: 'Uus aadress',
        toPort: 'Uus port',
        snatTo: 'Uus lähe (tühi = masquerade)',
        snatToHint: 'Selgesõnaline lähteaadress; tühi = masquerade väljumisaadressil',
        addDnat: 'Lisa DNAT-reegel',
        addSnat: 'Lisa SNAT-reegel',
        routesTitle: 'Staatilised marsruudid',
        routesHint: 'Sõlm marsruudib nende võrkude vahel, millega ta on ühendatud (IP forwarding on sees); need marsruudid lisavad kättesaadavust neist kaugemale — puhas kernel, dünaamiline marsruutimine tuleb mõne järgmise vooruga.',
        routeDestination: 'Siht-alamvõrk',
        routeGateway: 'Järgmine hüpe',
        routeMetric: 'Meetrika',
        addRoute: 'Lisa marsruut',
        listening: 'Kuulab aadressil',
        rules: '{d} DNAT · {o} 1:1 · {s} SNAT · {r} marsruuti'
      },
      unknownSince: 'Teadmata — viimane raport {m} min tagasi',
      lastWord: 'Viimane sõna',

      // Voor #156 (dialoogi standard): vaadeldud read ja kind-ploki
      // kirjutuskaitstud kokkuvõte üksikasjade dialoogis.
      reportObservedAt: 'Viimane raport',
      lastErrorRow: 'Viimane viga',
      recordsCount: '{n} käsitsi kirjet',
      phase: {
        configured: 'Konfigureeritud',
        running: 'Töötab',
        error: 'Viga'
      },
      authorityNode: 'Authority (määramine)',
      preferredNode: 'Eelistatud sõlm',
      preferredNodeHint: 'Pehme eelistus, mitte kunagi piirang: järgmisel paigutusotsusel maandub instants siia, kui see liige on sobilik — iseenesest ei liiguta ta midagi; käik on "Anna authority üle".',
      noPreference: 'Eelistust ei ole (automaatne paigutus)',
      moving: 'Liikumas',
      movingTooltip: 'Vaadeldud siin, sel ajal kui authority määrab {node}: käik on koondumas.',
      placement: {
        title: 'Paigutus',
        loading: 'Loendus käib…',
        loadError: 'Paigutuse loendus ei vastanud — proovi hiljem uuesti.',
        draftHint: 'Loendus arvutatakse deklareeritud võrguühenduse põhjal: see ilmub, kui teenus on loodud. Loomine lükatakse tagasi, kui ükski liige ei saa teda teenindada, ja tagasilükkamine nimetab mehhanismi, mis hulga tühjendas.',
        eligibleCount: '{n} liiget {m}-st saab seda instantsi teenindada',
        recommended: 'Soovitatud',
        eligible: 'Sobilik',
        notEligible: 'Ei ole sobilik',
        blockedReachability: 'võrk ei jõua selle liikmeni',
        blockedRequireTag: 'blokeeritud nõutava sildi tõttu (requireNodes)',
        blockedExcluded: 'simulatsiooniga välja jäetud',
        preferenceUnknown: 'ta ei ole (enam) klastri liige',
        preferenceIgnored: 'Eelistus "{node}" ei ole täna sobilik: {reason}. Peale jääb loenduse soovitus — mitte kunagi viga, teenus elab mujal.',
        emptyReachability: 'Ükski liige ei saa seda instantsi teenindada: võrk ei jõua mitte kuhugi — ükski sildimuudatus ei aita. Kaabelda sõlm või vii teenus sinna, kus võrk on olemas.',
        emptyRequireTag: 'Ükski liige ei saa seda instantsi teenindada: hulga tühjendasid just nõutavad sildid — eemalda kirje requireNodes-ist või sildista mõni liige.',
        spof: 'Üksik tõrkepunkt',
        spofDetail: 'Instantsi saab majutada täpselt üks liige: tõrke korral ei ole failoveril kuhugi minna. Mitme listeneriga teenus liigub ÜHE TERVIKUNA — kandidaat peab nägema KÕIKI tema võrke: see on hind.',
        whatIf: 'Simuleeri liikmete puudumist',
        whatIfHint: 'Tühjenduse what-if: küsi ENNE evakueerimist, ära avasta seda alles failoveri hetkel.',
        survives: 'Kui {nodes} on ära, on teenusel ikka veel kodu.',
        notSurvives: 'Pärast {nodes} evakueerimist on see teenus MAAS: tuletatud piirang võidab käideldavuse (R30) — deemon, mis on elus seal, kuhu võrk ei jõua, ei teeninda kedagi ega hoiata kedagi.',
        transfer: 'Anna authority üle',
        transferError: 'Üleandmine nurjus',
        transferTarget: 'Sihtliige',
        transferHint: 'Pakutakse ainult sobilikke liikmeid — eelistus kehtiva hulga sees, mitte kunagi override. Ei mingit taski: workeri järgmine läbimine ONGI käik (vana sõlm koristab, uus loob).'
      }
    },
    fabric: {
      tabDerivation: 'Tuletus',
      importNetwork: 'Impordi teisest fabricust',
      importTitle: 'Impordi loogiline võrk',
      importHint: 'Import on selgesõnaline liitumine: võrk jääb omanikule (sama identiteet, sama stem, sama bridge tvf-<stem>) ja siit kaardistatakse see selle fabricu portidele/LAGG-idele — kaardistada TÄHENDAB kinnitada, et edastus jõuab samasse L2-domeeni kui omanikul.',
      importPick: 'Omaniku võrk',
      importNone: 'Pole midagi importida: teistel fabricutel pole oma võrku, mida see fabric juba ei tunneks',
      importedNetworksTitle: 'Imporditud võrgud',
      noImported: 'Imporditud võrke pole',
      importedFrom: 'imporditud fabricust {fabric}',
      importedBy: 'Importinud: {list}',
      importedCount: '+{n} imporditud',
      owner: 'Omanik',
      bridge: 'Bridge',
      bond: 'Bond',
      unimport: 'Eemalda import',
      unimportConfirm: 'Kas eemaldada võrgu {name} (omanik {fabric}) import sellest fabricust? Keeldutakse, kuni mõni selle fabricu port või LAGG seda kaardistab või mõnda külalist, App-i või teenust teenindatakse ainult selle jala kaudu.',
      unimportRefused: 'Import on veel kasutusel — {detail}',
      deriv: {
        codeHint: {
          deviceHeldByFabric: 'See node saab selle võrgu juba teisest fabricust, mille liige ta on: node võtab jagatud võrgu ainult ÜHE oma jala kaudu (kaks sama L2 uplinki ilma STP-ta bridge’is on silmus). Eemalda kaardistus ühe kahest fabricust portidel või LAGG-il.',
          otherFabricDerived: 'Dokument kannab fabricu plokki, mille poole node enam kaablit ei deklareeri: rakenda enne selle fabricu plaan (see pakub tema seadmete eemaldamist) või võta need take-ownership’iga üle, kui fabricut enam pole.'
        },
        hint: 'O.3 tuletusplaan: iga kaabeldatud node\'i kohta olek, diff tuletatud-vs-praegune, DEKLAREERITUD bond-topoloogia, dual-stack flipid ja struktureeritud keeldumised/hoiatused. Kirjutuskaitstud kuni EKSPLITSIITSE apply\'ni — miski ei maandu kunagi node\'ile iseenesest.',
        refresh: 'Laadi plaan uuesti',
        empty: 'Ükski node pole selle fabricu külge kaabeldatud (ja ükski ei kanna enam selle plokki).',
        refusal: 'Keeldumine',
        warning: 'Hoiatus',
        generation: 'dokumendi generatsioon {n}',
        state: {
          manual: 'Manuaalne',
          derived: 'Tuletatud',
          diverged: 'Kõrvale kaldunud'
        },
        topologyTitle: 'Deklareeritud topoloogia',
        members: 'liikmed',
        primary: 'esmane',
        held: 'hoitud ÜHEL liikmel',
        form: {
          perNetworkBond: 'Bond võrgu kohta',
          singleBond: 'Üks fallback-bond',
          laggBond: 'LACP-bond (LAGG)',
          singlePort: 'Üks port'
        },
        colAction: 'Toiming',
        colKind: 'Liik',
        colDevice: 'Device',
        colDetail: 'Üksikasi',
        action: {
          add: 'lisa',
          remove: 'eemalda',
          replace: 'asenda'
        },
        diffEmpty: 'Ootel diffi pole — rakendatud dokument kattub renderiga.',
        diffBlocked: 'Diffi pole: ülaltoodud keeldumised blokeerivad selle node\'i.',
        phasePlanned: 'planeeritud (samm 1/3)',
        phaseDraining: 'tühjenemas (samm 2/3)',
        probeUnobserved: 'Tühjendussond: kunagi raporteerimata — tühjus on TEADMATA (retire keeldutaks praegu).',
        probeFailed: 'Tühjendussond: vaatlus EBAÕNNESTUS — teadaolevad ajatemplid kanduvad edasi, mitte kunagi «tühi», mida keegi pole mõõtnud.',
        probeActive: {
          one: 'Sond: {n} loodud ühendus endiselt vanal aadressil',
          other: 'Sond: {n} loodud ühendust endiselt vanal aadressil'
        },
        probeLastActive: 'viimane aktiivsus {time}',
        probeEmpty: {
          one: 'Sond: tühi {n} minut',
          other: 'Sond: tühi {n} minutit'
        },
        probeEmptyUnknown: 'Sond: tühi (mis ajast, teadmata).',
        impact: '{nics} vNIC-i ja {apps} Appi sellel node\'il kasutavad neid võrke: {list}',
        apply: 'Rakenda sellele node\'ile',
        applyTitle: 'Rakenda tuletus — {node}',
        applyIntro: 'Tuletatud konfiguratsioon kirjutab node\'i {node} võrgudokumendi ümber ({n} muudatust) sama ukse kaudu kui host-network-editor — NetworkManageri checkpoint ja aus probe kaasa arvatud. Plaani hoiatused allpool reisivad kaasa: loe need enne kinnitamist läbi.',
        applyError: 'Apply ebaõnnestus',
        applyRefused: 'Node keeldus:',
        planMoved: 'Fabric muutus pärast seda eelvaadet — MIDAGI ei rakendatud. Plaan on uuesti laaditud: vaata uuesti ja proovi uuesti.',
        retire: 'Kõrvalda',
        retireTitle: 'Tagasipöördumatuse punkt — aadressi {address} kõrvaldamine',
        restore: 'Taasta',
        restoreTip: 'Tagasi apply-eelsesse hetktõmmisesse (põlvkond {previous}) — ühe sammu tagasivõtt (H13)',
        restoreTitle: 'Taasta eelmine dokument — {node}',
        restoreIntro: 'Sõlme {node} võrgudokument läheb tagasi viimase apply eel tehtud hetktõmmisesse (põlvkond {previous}), kirjutatuna uuesti põlvkonnana {next} põlvkonna {current} asemel. Worker ühtlustab selle nagu iga teise dokumendi.',
        restoreRedo: 'Asendatud dokument saab uueks hetktõmmiseks: uuesti taastamine on redo.',
        restoreClosesChain: 'Hetktõmmis on tuletuseelne käsitsi dokument: ahel lõpeb siin — rohkem tagasivõttu pole, sõlm on käsitsi kuni järgmise apply-ni.',
        restoreConfirm: 'Taasta',
        restoreError: 'Taastamine ebaõnnestus',
        retireIntro: 'See eemaldab aadressi {address} ({network}) punktist {point} lõplikult. Pärast seda tegu on tagasitee PÖÖRD-flip — vana aadressi uuesti deklareerimine sama mootori kaudu — mitte kunagi pime taastamine.',
        retireOld: 'Vana aadress (eemaldatud)',
        retireNew: 'Uus aadress (jääb)',
        retireEmptyFact: 'Tühjendussond raporteerib aadressi tühjaks: see eemaldamine ei katkesta ühtegi vaadeldud ühendust.',
        retireConfirm: 'Kõrvalda aadress',
        severActiveLoss: {
          one: 'Katkesta {n} loodud ühendus endiselt vanal aadressil — see sureb selle teoga',
          other: 'Katkesta {n} loodud ühendust endiselt vanal aadressil — need surevad selle teoga'
        },
        severUnknownLoss: 'Aktsepteeri TEADMATUST: sond pole seda aadressi kunagi vaadelnud (või vaatlus ebaõnnestub) — elusaid ühendusi võidakse katkestada.'
      },
      title: 'Fabric',
      createTitle: 'Loo fabric',
      networks: 'Võrgud',
      switches: 'Switchid',
      ports: 'Pordid',
      laggs: 'LAGG-id',
      subnets: 'Alamvõrgud',
      tabOverview: 'Ülevaade',
      tabNetworks: 'Loogilised võrgud',
      tabSwitches: 'Switchid',
      overviewHint: 'Fabric ühe pilguga: iga loogiline võrk koos MTU ja alamvõrguga (VLAN-id elavad ainult pordi- ja LAGG-põhistes vastendustes — sama võrk võib eri portides liikuda eri siltidega). Fabric on VÄLISE taristu register — TVirt vaatleb ja deklareerib, ei provisioneeri kunagi ning puudutab ainult neid NIC-e, mis on registreeritud tema kontrolli alla.',
      absorptionHint: 'Iga siin deklareeritud alamvõrk TULETAB sama kirjutusega oma kirje IPAM-i registris — see elab ja sureb koos võrguga.',
      scopeFixedHint: 'Scope on fikseeritud klastri juurele: füüsiline taristu on definitsiooni järgi kogu klastri oma.',
      networksHint: 'Iga võrk kannab kohustuslikku MTU-d (vaikimisi 1500) ja kohustuslikku alamvõrku; siin deklareeritud gateway, DNS-serverid ja staatilised marsruudid on AINUS ALLIKAS serverite NIC-idele, rakendustele ja võrguteenustele.',
      switchesHint: 'Käsitsi peetav register: port on kas kasutamata, vastendatud (untagged liiklus ja VLAN-siltide kaupa loogilistele võrkudele) või LAGG-i liige — liige ei kanna omaenda vastendusi.',
      mtu: 'MTU',
      cidr: 'CIDR',
      cidrHint: 'Kohustuslik — IPAM tuletab sellest automaatselt registrikirje',
      nodeAddressing: 'Sõlmede adresseerimine',
      nodeAddressingNone: 'Puudub — sõlmele aadressi ei anta',
      nodeAddressingPool: 'Pool — üks püsiv aadress iga teenindatud sõlme kohta',
      nodeAddressingHint: 'Pool puhul määrab fabric\'u tuletus igale teenindatud sõlmele aadressi TVirt-ile reserveeritud vahemikest (pärast määramist püsiv).',
      backing: 'Backing',
      gateway: 'Gateway',
      ranges: 'Reserveeritud vahemikud',
      dns: 'DNS-serverid (komadega eraldatud)',
      dnsShort: 'DNS',
      singleSourceHint: 'Siin deklareeritud gateway, DNS ja marsruudid on ainus allikas — serverite NIC-id, rakendused ja võrguteenused ammutavad siit',
      routesTitle: 'Staatilised marsruudid',
      routeDestination: 'Sihtkoht (CIDR)',
      routeVia: 'Kaudu (järgmine hüpe)',
      portUsed: 'Kasutusel',
      vlanMappings: 'VLAN-i vastendused',
      vlanTag: 'VLAN-silt',
      vlanNetwork: 'Loogiline võrk',
      nameTaken: 'Nimi on fabricus juba kasutusel',
      addNetwork: 'Lisa võrk',
      editNetwork: 'Muuda võrku',
      deleteNetwork: 'Eemalda võrk',
      deleteNetworkConfirm: 'Kas eemaldada loogiline võrk {name} fabricust? Tema tuletatud alamvõrk IPAM-is sureb koos temaga (keeldutakse seni, kuni mõni teenus või rakendus seda kasutab). Portide ja LAGG-ide vastendused, mis sellele viitavad, eemaldatakse.',
      switchName: 'Switch',
      portName: 'Port',
      positionHint: 'Füüsiline asukoht (valikuline) — sama sõnavara mis serverite paigutusel; ainult deklaratiivne',
      addSwitch: 'Lisa switch',
      editSwitch: 'Muuda switchi',
      deleteSwitch: 'Eemalda switch',
      deleteSwitchConfirm: 'Kas eemaldada switch {name} koos kõigi tema portidega? LAGG-id kahanevad vastavalt (ja surevad alla kahe pordi).',
      addPort: 'Lisa port',
      editPort: 'Muuda porti',
      deletePort: 'Eemalda port',
      deletePortConfirm: 'Kas eemaldada port {name}?',
      untagged: 'Untagged',
      tagged: 'Tagged (silt:võrk)',
      taggedShort: 'Tagged',
      portCabling: 'Kaabeldus',
      portState: 'Olek',
      stateUnused: 'kasutamata',
      stateMapped: 'vastendatud',
      laggPortGuard: 'LAGG-i liikmeks olevat porti muudetakse LAGG-i poolelt',
      laggsTitle: 'LAGG',
      laggsHint: 'LAGG on 2+ porti LACP-s ja võib ulatuda üle switchide (MLAG, läbipaistvalt); sisse pääsevad ainult kasutamata pordid, LAGG on vastendamispind ja eemaldatud port muutub taas kasutamata pordiks.',
      addLagg: 'Lisa LAGG',
      editLagg: 'Muuda LAGG-i',
      deleteLagg: 'Eemalda LAGG',
      deleteLaggConfirm: 'Kas eemaldada LAGG {name}? Tema liikmespordid muutuvad taas kasutamata portideks.',
      lacpRate: 'LACP sagedus',
      laggPorts: 'Liikmespordid (2+)',
      laggPortsHint: 'Sisse pääsevad ainult kasutamata pordid — vabasta kõigepealt mõni vastendatud port',
      noNetworks: 'Ühtegi loogilist võrku pole deklareeritud.',
      noSwitches: 'Ühtegi switchi pole deklareeritud.',
      noLaggs: 'Ühtegi LAGG-i pole deklareeritud.',
      staleConflict: 'Teine operaator muutis seda fabricut, samal ajal kui sa seda muutsid: salvestamine lükati tagasi, et tema tööd mitte kustutada. Sinu muudatused on endiselt siin, puutumata. Uuendatud fabric on juba uuesti laaditud: kinnita uuesti, et need selle peale rakendada, või katkesta ja vaata, mis muutus.'
    },
    ipam: {
      title: 'IPAM',
      derivedHint: 'Ainult tuletatud: iga alamvõrk sünnib loogilisest fabric-võrgust või overlay-võrgust — muudatused tehakse allikas. Määratud aadressid näitavad, KES neid hoiab; TVirtile reserveeritud vahemikud on automaatse määramise kogumid.',
      search: 'Otsi nime, CIDR-i või aadressi järgi',
      empty: 'Ühtegi võrku pole — deklareeri loogiline fabric-võrk või overlay-alamvõrk: IPAM tuletab need nendest automaatselt.',
      reserved: 'TVirtile reserveeritud vahemikud',
      address: 'Aadress',
      origin: 'Päritolu',
      origin_declared: 'deklareeritud',
      origin_observed: 'vaadeldud',
      holder: 'Hoidja',
      noAddresses: 'Selles alamvõrgus pole ühtegi teadaolevat aadressi.',
      sourceFabric: 'Fabric',
      sourceOverlay: 'Overlay',
      editAtSource: 'Muuda allikas'
    },

    // Rete > Firewall (#168): il vocabolario dei gruppi + la terna per-NIC.
    firewall: {
      title: 'Tulemüürigrupid',
      createTitle: 'Uus tulemüürigrupp',
      editTitle: 'Muuda tulemüürigruppi',
      empty: 'Ühtegi tulemüürigruppi pole veel — loo üks: taaskasutatav reeglisõnavara, millele külaliste NIC-id viitavad nime järgi.',
      nameHint: "Tähed, numbrid ja seesmised . - _; unikaalne oma scope'i piires (mujal olevaid nimekaimusid eristab /scope/nimi)",
      description: 'Kirjeldus',
      descriptionHint: 'Üks rida kavatsust, näha kõikjal, kus gruppi valitakse',
      enforced: "Jõustatud scope'il",
      enforcedHint: "Väljas: puhas sõnavara — reeglid seovad ainult neid NIC-e, mis grupile viitavad. Sees: reeglid seovad grupi scope'i all iga külalise NIC-i, mille tulemüür on sees — viidatud või mitte.",
      enforcedChip: 'Jõustatud',
      enforcedChipHint: "Reeglid seovad grupi scope'i all iga külalise NIC-i, mille tulemüür on sees — viidatud või mitte",
      enforceWarning: 'Jõustamise sisselülitamisel seovad reeglid järgmisel ühtlustamisel {scope} all IGA külalise NIC-i, mille tulemüür on sees, ka ilma otsese viiteta — ja aktiivse chaini sees on esivanema drop lõplik: alumised tasemed seda uuesti ei ava.',
      unenforceInfo: 'Jõustamise mahavõtmisel jäävad reeglid ainult NIC-idele, mis grupile otse viitavad.',
      rules: 'Reeglid',
      tabOverview: 'Ülevaade',
      tabRules: 'Reeglid',
      orderHint: 'Ridade järjekord ONGI hindamisjärjekord grupi sees: võidab esimene sobiv reegel.',
      statefulHint: 'Stateful on kaudne: vastused lubatud liiklusele pääsevad läbi ise (established/related võetakse vastu, invalid visatakse minema — need süstib mootor, käsitsi neid ei kirjutata).',
      noRules: 'Reegleid pole — sõnavara alles valmib: sellele viitamine on lubatud ega renderda midagi.',
      addRule: 'Lisa reegel',
      direction: 'Suund',
      directionIn: 'Sissetulev',
      directionOut: 'Väljaminev',
      action: 'Tegevus',
      action_accept: 'Luba',
      action_drop: 'Hülga',
      action_reject: 'Lükka tagasi',
      protocol: 'Protokoll',
      protocolAny: 'Suvaline',
      ports: 'Pordid',
      source: 'Allikas',
      dest: 'Sihtkoht',
      comment: 'Kommentaar',
      addressHint: 'IPv4 CIDR või <fabric>/<loogiline võrk>; tühi = suvaline',
      moveUp: 'Liiguta üles',
      moveDown: 'Liiguta alla',
      nicFirewall: 'Tulemüür',
      nicAntiSpoof: 'Anti-spoofing',
      nicGroups: 'Tulemüürigrupid',
      nicGroupsPlaceholder: 'Vali grupp…',
      nicGroupsHint: "Nähtavad grupid, kaasa arvatud ülemiste scope'ide omad (kasutatavad allapoole, nagu sildid)",
      nicGroupCount: { one: '{n} tulemüürigrupp', other: '{n} tulemüürigruppi' },
      nicOff: 'Tulemüür väljas',
      pendingRestartHint: "Tulemüüri muudatused järgivad salvestatud/rakendatud mudelit: need ootavad järgmist toitetsüklit (PendingRestart). Ülemiste scope'ide jõustatud grupid rakenduvad, kui NIC-i tulemüür on sees.",
      appConvergeHint: "Tulemüüri muudatused rakenduvad konteineri järgmisel ühtlustamisel. Ülemiste scope'ide jõustatud grupid rakenduvad, kui tulemüür on sees.",
      enforcedAncestors: "Jõustatud ülemiste scope'ide poolt",
      enforcedAncestorsHint: "See grupp rakendub igale NIC-ile oma scope'i all, mille tulemüür on SEES — lüliti on NIC-i pealüliti (väljas = ei mingit chaini, esivanemad kaasa arvatud); aktiivse chaini sees on esivanema autoriteet lõplik: tema drop allpool uuesti ei avane."
    }
  }
}
